import { Grid, Typography } from "@material-ui/core";
import WidgetTitle from "../WidgetTitle/WidgetTitle";
import { soldThisMonthStyle } from "./style";

const DEMO_COUNT = 14;
const DEMO_NET_SAR = 182430;

const numberFormatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });

const SoldThisMonthWidget = () => {
    const classes = soldThisMonthStyle();

    return (
        <Grid container direction="column" className={classes.graphWrapper}>
            <Grid item>
                <WidgetTitle
                    title="Sold This Month"
                    info="Count of vehicles sold in the current calendar month and total net-to-client value."
                />
            </Grid>
            <Grid item className={classes.body}>
                <Typography className={classes.count}>{DEMO_COUNT}</Typography>
                <Typography className={classes.countLabel}>Vehicles Sold This Month</Typography>
                <div className={classes.divider} />
                <Typography className={classes.netLine}>
                    Net-to-Client:&nbsp;&nbsp;SAR {numberFormatter.format(DEMO_NET_SAR)}
                </Typography>
            </Grid>
        </Grid>
    );
};

export default SoldThisMonthWidget;
